import React from 'react';
import PropTypes from 'prop-types';

const IcoValue = ({ value, children }) => {
  const iconStyle = {
    width: 20,
    height: 15,
    borderRadius: '3px',
    marginRight: '8px'
  };
  const colorStyle = {
    width: 20,
    height: 15,
    backgroundColor: value.bg,
    display: 'inline-block',
    borderRadius: '3px',
    marginRight: '8px'
  };

  let iconState;
  if (value.icon) {
    iconState = <img src={value.icon} style={iconStyle} role="presentation" />;
  } else if (value.bg) {
    iconState = <span style={colorStyle} />;
  } else {
    iconState = '';
  }

  return (
    <div className="Select-value">
      <span className="Select-value-label">
        {iconState} {children}
      </span>
    </div>
  );
};

IcoValue.propTypes = {
  children: PropTypes.node,
  value: PropTypes.object
};

export default IcoValue;



// WEBPACK FOOTER //
// ./src/components/OptionSelector/IcoValue.js


// WEBPACK FOOTER //
// webpack:///src/components/OptionSelector/IcoValue.js